import * as React from "react";
import { IconNames } from "@blueprintjs/icons";
import { ETLCodes } from "../../locales/ETLCodes";
import { useTl } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";
import { Intent, Button } from "@blueprintjs/core";

interface IPreviousButtonProps extends ICustomButtonProps {
  className?: string;
}

export const PreviousButton: React.FunctionComponent<IPreviousButtonProps> = ({
  minimal,
  onClick,
  disabled,
  loading,
  intent = Intent.NONE,
  hideText,
  className
}) => {
  const { t } = useTl();

  return (
    <Button
      icon={IconNames.CHEVRON_LEFT}
      minimal={minimal}
      onClick={onClick}
      text={hideText ? null : t(ETLCodes.Precedent)}
      intent={intent}
      loading={loading}
      disabled={disabled}
      className={className}
    />
  );
};
